export default __webpack_public_path__ + "static/media/VIB_TRAN.de816f79.png";